<template>
  <card>
    <h4 slot="header" class="card-title">Compañía</h4>
    <form v-if="company">
      <div class="row">
        <div class="col-md-6">
          <base-input type="text" label="Nombre" :disabled="false" placeholder="Compañía" v-model="company.name">
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input type="text" label="Dirección" :disabled="false" placeholder="Dirección" v-model="company.address">
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <base-input type="text" label="Ciudad" :disabled="false" placeholder="Ciudad" v-model="company.city">
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input v-if="company.status == true" label="Estado" :disabled="true" placeholder="Estado" value="Activo">
          </base-input>
          <base-input v-else label="Estado" :disabled="true" placeholder="Estado" value="Inactivo">
          </base-input>
        </div>
        <div style="padding-left: 15px;" class="col-md-6">
          <vs-input type="file" @change="getImageLogo" accept="image/*" label="Logo" />
        </div>
        <div style="-webkit-writing-mode: vertical-lr; align-self: self-end;" class="col-md-6">
          <button style="border: none; background-color: #0d6efd;" class="btn btn-info btn-fill float-right"
            @click.prevent="editCompanieStore()">
            Actualizar
          </button>
        </div>
      </div>
      <div style="-webkit-writing-mode: vertical-lr;">
        <center><br>
          <img id="img_logo" :src="company.logo">
        </center>
      </div>
      <div class="clearfix"></div>
    </form>
  </card>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import getSecret from '../../helpers/get-secret';
const serverUrl = getSecret('SERVER_URL');

export default {
  components: {
    Card
  },
  data() {
    return {
      user: {
        name_company: JSON.parse(localStorage.getItem('jwt_licencia')).name,
        email: window.localStorage.getItem('jwt_user'),
      },
      id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
      company: {
        logo: '',
        file_logo: null,
        name: '',
        address: '',
        city: '',
        id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
      },
    }
  },
  methods: {
    editCompanieStore() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      console.log(this.id_company);
      var data = new FormData();
      data.append('file_logo', this.company.file_logo);
      data.append('name', this.company.name);
      data.append('address', this.company.address);
      data.append('id_company', this.id_company);
      data.append('city', this.company.city);
      this.axios.post(serverUrl + '/api/editCompanieStore', data)
        .then(res => {
          if (res.data.status == 200) {
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Compañía Actualizada.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            });
            this.getCompanyData();
            this.$vs.loading.close();
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al actualizar la Compañía.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
        })
        .catch(err => {
          console.log(err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al actualizar la Compañía.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
        });

    },
    getImageLogo(event) {
      this.company.file_logo = event.target.files[0];
      this.company.logo = event.target.result
      var reader = new FileReader();
      reader.onload = function (e) {
        document.getElementById('img_logo').src = e.target.result
      }
      reader.readAsDataURL(event.target.files[0])
    },
    getCompanyData() {
      this.axios.get(serverUrl + '/api/getCompanyData/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            this.company = res.data.company;
          } else {
            console.log(res.data);
          }
        })
        .catch(err => {
          console.log(err.data);
        });
    },
  },
  mounted() {
    this.getCompanyData();
  }
}

</script>
<style>
input[type='file'] {
  width: 80%;
}

input[type=file]::file-selector-button {
  width: 50%;
  margin: 2px 0 15px 0;
  border: none;
  background: #0d6efd;
  padding: 6px;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  transition: background .2s ease-in-out;
}

input[type=file]::file-selector-button:hover {
  background: #0d45a5;
}
</style>
